<i18n>
{
	"en": {
		"volume": "Volume",
		"grossWeight": "Gross Weight",
		"licencePlate": "Licence Plate"
	},
	"no": {
		"volume": "Volum",
		"grossWeight": "Brutto vekt",
		"licencePlate": "Kollinummer"
	}
}
</i18n>

<template>
	<div
		class="container"
	>
		<t-grid
			v-if="packages && packages.length"
			:items="packages"
			idKey="licencePlate"
			:columnDefinitions="columnDefinitions"
			:rowHeight="30"
			:showFilters="false"
		/>
	</div>
</template>

<script>
import TGrid from '@/components/evergreen/timpex/grid/TGrid';
export default {
	name: 'Packages',
	components: { TGrid },
	props: {
		order: Object,
	},
	computed: {
		packages() {
			return this.order.packages;
		},
		columnDefinitions() {
			return [{
				field: 'licencePlate',
				displayName: this.$t('licencePlate'),
				width: 200,
				resizable: true,
			},
			{
				field: 'grossWeight',
				displayName: this.$t('grossWeight'),
				width: 120,
				resizable: true,
			},
			{
				field: 'volume',
				displayName: this.$t('volume'),
				resizable: true,
			}];
		}
	}
};
</script>

<style lang="scss" scoped>

.container {
	height: 100%;
}

</style>
